import { useDispatch, useSelector } from 'react-redux';

import {
  setAuthProcess,
  clearAuthProcess,
  getAuth,
  setRedirectUrlProcess,
  setLoginCheckedProcess,
  setLoggedProcess,
} from 'features/auth/redux/slice';
import { AuthApiResponse } from './types';
import { AxiosError } from 'axios';
import { useNavigate } from 'react-router-dom';

const useAuth = () => {
  const auth = useSelector(getAuth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const setAuth = (props: AuthApiResponse) => {
    dispatch(setAuthProcess(props));
  };

  const clearAuth = () => {
    dispatch(clearAuthProcess());
  };

  const setRedirectUrl = (url: string | null) => {
    dispatch(setRedirectUrlProcess(url));
  };

  const setLoginChecked = (loginChecked: boolean) => {
    dispatch(setLoginCheckedProcess(loginChecked));
  };

  const setLogged = (logged: boolean) => {
    dispatch(setLoggedProcess(logged));
  };

  const authHandlingError = (error: AxiosError, callback = (error?: AxiosError) => {}) => {
    if (error && error.response && error.response.status) {
      if (error.response.status === 401) {
        navigate('/logout', { replace: true });
      }
    }

    callback(error);
  };

  return {
    ...auth,
    setAuth,
    clearAuth,
    setRedirectUrl,
    authHandlingError,
    setLoginChecked,
    setLogged,
  };
};

export default useAuth;
